import { render, staticRenderFns } from "./CustomerShortDetailButton.vue?vue&type=template&id=3360cd68&lang=pug&"
import script from "./CustomerShortDetailButton.vue?vue&type=script&lang=js&"
export * from "./CustomerShortDetailButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomerShortDetailButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports